import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { ShieldCheck, FileCheck, Award, Building2 } from 'lucide-react';

export const Certification = () => {
  return (
    <section id="certification" className="py-24 bg-background">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <Badge className="bg-primary/10 text-primary border-primary/30 mb-4">
            Offiziell zertifiziert
          </Badge>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-foreground mb-4" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
            Kantonale Bewilligung & Zertifizierung
          </h2>
          <p className="text-lg text-muted-foreground">
            Pneu-Idris verfügt über alle notwendigen Bewilligungen und Zertifizierungen für die professionelle Reifenentsorgung
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          <Card className="border-2 border-primary/20 shadow-xl">
            <CardHeader className="bg-gradient-to-r from-primary/5 to-secondary/5 border-b border-border">
              <div className="flex flex-col md:flex-row items-center md:items-start space-y-4 md:space-y-0 md:space-x-6">
                <div className="flex-shrink-0">
                  <img 
                    src="/images/logo-stamp.png" 
                    alt="Offizielle Zertifizierung Pneu-Idris" 
                    className="w-56 h-56 md:w-64 md:h-64 object-contain"
                  />
                </div>
                <div className="flex-1 text-center md:text-left">
                  <CardTitle className="text-2xl font-bold text-foreground mb-2" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
                    Offizielle Betriebsbewilligung
                  </CardTitle>
                  <p className="text-muted-foreground mb-3">Kantonal anerkannt und zertifiziert</p>
                  <div className="flex items-center justify-center md:justify-start space-x-2">
                    <ShieldCheck className="w-5 h-5 text-secondary" />
                    <span className="text-sm text-foreground font-medium">Betriebsnummer: 413400028</span>
                  </div>
                </div>
              </div>
            </CardHeader>
            <CardContent className="p-8">
              <div className="grid md:grid-cols-2 gap-8">
                <div className="space-y-6">
                  <div className="flex items-start space-x-3">
                    <Building2 className="w-5 h-5 text-secondary mt-1" />
                    <div>
                      <p className="font-semibold text-foreground mb-1">Firma</p>
                      <p className="text-muted-foreground">Pneu-Idris</p>
                    </div>
                  </div>
                  
                  <div className="flex items-start space-x-3">
                    <FileCheck className="w-5 h-5 text-secondary mt-1" />
                    <div>
                      <p className="font-semibold text-foreground mb-1">Betriebsnummer</p>
                      <p className="text-muted-foreground font-mono">413400028</p>
                    </div>
                  </div>

                  <div className="flex items-start space-x-3">
                    <Award className="w-5 h-5 text-secondary mt-1" />
                    <div>
                      <p className="font-semibold text-foreground mb-1">Verantwortliche Person</p>
                      <p className="text-muted-foreground">Herr Louay Idris</p>
                    </div>
                  </div>
                </div>

                <div className="bg-muted/30 rounded-lg p-6 space-y-4">
                  <h4 className="font-semibold text-foreground flex items-center">
                    <ShieldCheck className="w-5 h-5 text-primary mr-2" />
                    Bewilligungen umfassen:
                  </h4>
                  <ul className="space-y-2 text-sm text-muted-foreground">
                    <li className="flex items-start">
                      <span className="text-secondary mr-2">•</span>
                      Fachgerechte Entsorgung von Altreifen
                    </li>
                    <li className="flex items-start">
                      <span className="text-secondary mr-2">•</span>
                      Lagerung und Verwertung von Reifenmaterial
                    </li>
                    <li className="flex items-start">
                      <span className="text-secondary mr-2">•</span>
                      Umweltgerechte Recyclingprozesse
                    </li>
                    <li className="flex items-start">
                      <span className="text-secondary mr-2">•</span>
                      Transport und Logistik von Altmaterial
                    </li>
                    <li className="flex items-start">
                      <span className="text-secondary mr-2">•</span>
                      Einhaltung aller kantonalen Vorschriften
                    </li>
                  </ul>
                </div>
              </div>

              <div className="mt-8 p-6 bg-secondary/10 border border-secondary/30 rounded-lg">
                <p className="text-sm text-foreground">
                  <strong>Hinweis:</strong> Pneu-Idris ist offiziell vom Kanton bewilligt und erfüllt alle gesetzlichen Anforderungen 
                  für die professionelle Reifenentsorgung. Wir garantieren eine umweltgerechte und nachhaltige Verwertung aller Materialien 
                  gemäß den geltenden Umweltschutzbestimmungen.
                </p>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>
  );
};
